import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const MenuRequestsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MenuRequestCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff8c42;
    box-shadow: 0 4px 12px rgba(10, 30, 61, 0.1);
    transform: translateY(-2px);
  }
`;

export const MenuCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const MenuCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;

  div {
    margin: 0;
  }

  strong {
    color: #0a1e3d;
    font-weight: 600;
  }
`;

export const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const PaginationInfo = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;
  white-space: nowrap;
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  button {
    font-size: 12px;
    padding: 6px 12px;
  }

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
    }
  }
`;

export const PageSizeControl = styled.div`
  min-width: 150px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
